var scope_0 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/059ee9e78c28df759090cad0215b3bd8.js').default;
var scope_1 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10c0f74155437f6dea8b973adb483604.js').default;
var scope_2 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16eeca7183ddfb494ce719169228cb01.js').default;
var scope_3 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/271b5288685054c2c6fec56eac3e755a.js').default;
var scope_4 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5a062b8670c529e0f93ace38273fd352.js').default;
var scope_5 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78da96ac2deb841a99235e6db8060604.js').default;
var scope_6 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7feeddf2def2aa7fb97e9a52de2b2c3.js').default;
var scope_7 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8ec7fb768596e00271b0d79a6294725.js').default;
var scope_8 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bfb332f9d1f1105dd8d47649d125fe8c.js').default;
var scope_9 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c15f2d7ef996aa72b3587daa627478cf.js').default;
var scope_10 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c45f9decf5d80e154c35e504335bf548.js').default;
var scope_11 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d5a22bd66aa1ebe1d754f216d2d0f605.js').default;
var scope_12 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec422d07c2f062e0650fcab54e1d6a8a.js').default;
var scope_14 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/edca8e96cfc7dfea30eef660a8be5ddc.js').default;
var scope_15 = require('/Users/dan/Projects/nus/sr3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fdd24079dd70495c04dbe1460a36d6ae.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15 )
    